var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.loading)?_c('v-container',{staticClass:"spinner"},[_c('div',{staticClass:"loader"},[_c('v-img',{staticClass:"image",attrs:{"src":"https://kinetics.co.ke/wp-content/uploads/2021/06/cropped-icon-270x270.jpg"}})],1)]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }